import React, { FC } from 'react';
import { useSessionQuery } from '@src/graphql/generated';
import { OpenChatButton } from '../OpenChatButton';
import { ClosedActionsProps } from './props';
import './styles.scss';

export const ClosedActions: FC<ClosedActionsProps> = ({ isUnread, onOpenChat, onArchive }) => {
  const { data: sessionData } = useSessionQuery();

  const isSiteAdmin = sessionData?.currentRecruiter.isSiteAdmin;

  return (
    <div className="opening-applicant-card-closed-actions">
      <div className="opening-applicant-card-closed-actions__view-profile">View details</div>

      {isSiteAdmin && (
        <div className="opening-applicant-card-closed-actions__chat" onClick={event => event.stopPropagation()}>
          <OpenChatButton isUnread={isUnread} onOpenChat={() => onOpenChat?.()} />
        </div>
      )}

      <div className="opening-applicant-card-closed-actions__text">
        Conversation was closed by the applicant. &nbsp;
        <span
          className="opening-applicant-card-closed-actions__archive"
          onClick={event => {
            event.stopPropagation();
            onArchive?.();
          }}
        >
          Click to archive
        </span>
        .
      </div>
    </div>
  );
};
